import {
  Button,
  Dialog,
  DialogContent,
  DialogTrigger,
  InputFieldProps,
} from "@bleu.builders/ui";
import React from "react";

import { SettingsCard } from "#/components/SettingsCard";

export const AlterPlanResourcesModal = ({ organization }) => {
  const fields = [
    {
      name: "days",
      label: "Dias",
      description: "Quantidade de dias a serem adicionados",
      type: "input",
      mode: "number",
    },
  ] as InputFieldProps[];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="bg-primary/20 text-primary border border-primary hover:bg-primary/10">
          Adicionar dias ao plano experimente
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90%] max-w-xl overflow-auto p-0">
        <SettingsCard
          title="Adicionar créditos e dias ao plano experimente."
          fields={fields}
          defaultValues={{ credits: 0, days: 0 }}
          actionText="Adicionar"
          _method="put"
          action={{
            path: `/admin/organizations/${organization.id}/update_plan_resources`,
          }}
          useFormSubmit
        />
      </DialogContent>
    </Dialog>
  );
};
